// api/scriptApi.js - Script çağırma API istekleri
import apiClient from './apiClient';

// JSON dosyasından kullanıcı oluşturma scriptini çalıştır
export const runCreateUsersScript = async () => {
  try {
    const response = await apiClient.post('/scripts/create-users-from-json');
    return response.data;
  } catch (error) {
    throw error;
  }
}; 